<template>
  <div id="app">
    <router-view />

    <vue-snotify></vue-snotify>

    <!-- Modals -->
    <record-manual-payment></record-manual-payment>
    <create-bill-run></create-bill-run>
    <view-all-bills></view-all-bills>
    <bill-run-logs></bill-run-logs>
    <add-bank-account></add-bank-account>
    <end-bank-account></end-bank-account>
    <reverse-transaction></reverse-transaction>
    <add-charge></add-charge>
    <delete-charge></delete-charge>
    <hold-bill></hold-bill>
    <commit-bill></commit-bill>
    <cancel-bill></cancel-bill>
    <delete-bill></delete-bill>
    <import-service-bundle></import-service-bundle>
    <bulk-service-bundle-change></bulk-service-bundle-change>
    <export-service-bundle></export-service-bundle>
    <transfer></transfer>
    <undo-transfer></undo-transfer>
    <commit-draft-bills></commit-draft-bills>
    <lodgement-run></lodgement-run>
    <debt-write-off></debt-write-off>
    <view-all-advances></view-all-advances>
    <add-fixed-payment></add-fixed-payment>
    <view-fixed-payments></view-fixed-payments>
    <update-site-address></update-site-address>
    <Refresh />
    <UpdateAllocationMethod />
    <Allocations />
<BulkBillDelete />
<add-manual-allocation/>

    <ConfirmationModal />

    <view-ssc-info></view-ssc-info>

    <slideout-panel />
    <add-service-bundle />
    <renew-contract />
    <add-priority-service-set />
    <add-priority-service />

    <honeycomb-footer v-if="isLoggedIn"></honeycomb-footer>
  </div>
</template>

<script>
import RecordManualPayment from "@/components/modals/RecordManualPayment.vue";
import CreateBillRun from "@/components/modals/CreateBillRun.vue";
import ViewAllBills from "@/components/modals/ViewAllBills.vue";
import BillRunLogs from "@/components/modals/BillRunLogs.vue";
import AddBankAccount from "@/components/modals/AddBankAccount.vue";
import EndBankAccount from "@/components/modals/EndBankAccount.vue";
import AddCharge from "@/components/modals/AddCharge.vue";
import DeleteCharge from "@/components/modals/DeleteCharge.vue";
import ReverseTransaction from "@/components/modals/ReverseTransaction.vue";
import HoldBill from "@/components/modals/HoldBill.vue";
import CommitBill from "@/components/modals/CommitBill.vue";
import CancelBill from "@/components/modals/CancelBill.vue";
import DeleteBill from "@/components/modals/DeleteBill.vue";
import Transfer from "@/components/modals/Transfer/Transfer.vue";
import UndoTransfer from "@/components/modals/UndoTransfer.vue";
import CommitDraftBills from "@/components/modals/CommitDraftBills.vue";
import LodgementRun from "@/components/modals/LodgementRun.vue";
import HoneycombFooter from "@/components/Footer.vue";
import ImportServiceBundle from "@/components/modals/ImportServiceBundle.vue";
import ExportServiceBundle from "@/components/modals/ExportServiceBundle.vue";
import AddServiceBundle from "@/components/panels/contracts-panel-components/modals/AddServiceBundle";
import RenewContract from "@/components/panels/contracts-panel-components/modals/RenewContract";
import DebtWriteOff from "@/components/modals/DebtWriteOff.vue";
import ViewSscInfo from "@/components/modals/ViewSscInfo.vue";
import BulkServiceBundleChange from "@/components/modals/BulkServiceBundleChange.vue";
import ViewAllAdvances from "@/components/modals/ViewAllAdvances.vue";
import Refresh from "@/components/modals/Refresh";
import BulkBillDelete from "@/components/modals/BillDeleteBulk";

import AddPriorityServiceSet from "@/components/panels/contracts-panel-components/modals/AddPriorityServiceSet";
import AddPriorityService from "@/components/panels/contracts-panel-components/modals/AddPriorityService";
import AddFixedPayment from "@/components/modals/AddFixedPayment.vue";
import ViewFixedPayments from "@/components/modals/ViewFixedPayments.vue";
import UpdateSiteAddress from "@/components/modals/UpdateSiteAddress.vue";

import UpdateAllocationMethod from "@/components/modals/AllocationMethodUpdate.vue";
import Allocations from "@/components/modals/Allocations.vue";
import ConfirmationModal from "@/components/modals/ConfirmationModal.vue";

import AddManualAllocation from "@/components/modals/AddManualAllocation.vue";
export default {
  computed: {
    isLoggedIn() {
      return this.$auth.accessToken !== null;
    },
  },
  created() {
    var now = Date.now();
    var exp =
      JSON.parse(window.localStorage.getItem("Auth.decodedToken")).exp * 1000 -
      120000;
    if (exp < now) {
      return this.$store.dispatch("tokenRefresh");
    }
    return this.$store.dispatch("autoRefresh");
  },

  mounted() {
    this.$store.dispatch("updateReleaseVersions");
  },
  components: {
    RecordManualPayment,
    AddManualAllocation,
    CreateBillRun,
    ViewAllBills,
    BillRunLogs,
    AddBankAccount,
    EndBankAccount,
    ReverseTransaction,
    AddCharge,
    DeleteCharge,
    HoldBill,
    CommitBill,
    CancelBill,
    DeleteBill,
    Transfer,
    UndoTransfer,
    CommitDraftBills,
    LodgementRun,
    HoneycombFooter,
    ImportServiceBundle,
    ExportServiceBundle,
    AddServiceBundle,
    // AddCommercialConfig,
    RenewContract,
    DebtWriteOff,
    ViewAllAdvances,
    ViewSscInfo,
    BulkServiceBundleChange,
    AddPriorityServiceSet,
    AddPriorityService,
    AddFixedPayment,
    ViewFixedPayments,
    UpdateSiteAddress,
    Refresh,BulkBillDelete,

    UpdateAllocationMethod,
    Allocations,
    ConfirmationModal
  },
};
</script>